module.exports = __webpack_public_path__ + "static/media/sc_30_i.59da2879.png";